import { Checkbox } from 'antd';
import { useCallback, useEffect, useState } from 'react';

import type { ClientStatusEnum } from '@app/components/RecordModal/components/RecordDetails/types';

import type { ContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import {
  PF,
  RECORD_STATUSES,
} from '@pages/Clients/NewClientsList/data/constants';
import { FilterWrapper } from '@pages/Clients/NewClientsList/ui';

export const RecordsStatusFilter: ContentType = ({ open, onClose, id }) => {
  const { filtersMap, onChangeRecordsStatuses } = useNewClientsListContext();

  const { recordsStatuses } = filtersMap.get(id)!;

  const [localStatuses, setLocalStatuses] = useState<ClientStatusEnum[]>([]);

  const onConfirm = useCallback(() => {
    onChangeRecordsStatuses(localStatuses, id);
    onClose?.();
  }, [localStatuses, onChangeRecordsStatuses, onClose, id]);

  const onChange = useCallback((checkedValues: ClientStatusEnum[]) => {
    setLocalStatuses(checkedValues);
  }, []);

  useEffect(() => {
    setLocalStatuses(open ? recordsStatuses : []);
  }, [open, recordsStatuses]);

  return (
    <FilterWrapper onConfirm={onConfirm}>
      <Checkbox.Group<ClientStatusEnum>
        className={`${PF}__checkbox-group`}
        options={RECORD_STATUSES}
        onChange={onChange}
        value={localStatuses}
      />
    </FilterWrapper>
  );
};
